import { useState } from 'react';

export default function Products() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(1);

  const products = [
    {
      id: 0,
      title: 'Óculos de Grau',
      description: 'Armações exclusivas com lentes de alta precisão',
      image: 'https://public.readdy.ai/ai/img_res/ce9e400b48a2987b961a4e378b2861aa.jpg'
    },
    {
      id: 1,
      title: 'Óculos de Sol',
      description: 'Proteção UV completa com design sofisticado',
      image: 'https://readdy.ai/api/search-image?query=premium%20sunglasses%20collection%20dramatic%20lighting%20dark%20elegant%20background%20luxury%20optical%20product%20photography%20high-end%20designer%20frames%20sophisticated%20style%20professional%20quality%20sharp%20details&width=600&height=800&seq=product-sunglasses&orientation=portrait',
      badge: 'MAIS VENDIDOS'
    },
    {
      id: 2,
      title: 'Lentes de Contato',
      description: 'Conforto e praticidade para o seu dia a dia',
      image: 'https://readdy.ai/api/search-image?query=person%20applying%20contact%20lens%20close-up%20lifestyle%20photography%20natural%20lighting%20clean%20aesthetic%20healthcare%20optical%20product%20modern%20lifestyle%20comfortable%20daily%20use%20professional%20quality&width=600&height=800&seq=product-contact-lenses&orientation=portrait'
    }
  ];

  return (
    <section id="produtos" className="py-16 md:py-32 px-6 md:px-20 bg-white" data-product-shop>
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-16">
          <div className="mb-6 md:mb-0">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-300 mb-1 md:mb-2">NOSSOS</h2>
            <h3 className="text-4xl md:text-6xl italic text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>Produtos</h3>
          </div>
          <p className="text-gray-600 text-sm md:text-base max-w-xl leading-relaxed">
            Explore nossa coleção exclusiva de armações e lentes de alta tecnologia, selecionadas para combinar estilo e funcionalidade
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="relative rounded-3xl overflow-hidden cursor-pointer transition-transform duration-300 group"
              style={{
                transform: hoveredCard === product.id ? 'scale(1.05)' : 'scale(1)',
                aspectRatio: '3/4'
              }}
              onMouseEnter={() => setHoveredCard(product.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="absolute inset-0">
                <img 
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              </div>

              {product.badge && (
                <div className="absolute top-4 md:top-6 left-4 md:left-6 bg-teal-400 text-gray-900 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs font-bold">
                  {product.badge}
                </div>
              )}

              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <h4 className="text-white text-2xl md:text-3xl font-bold mb-2 md:mb-3">{product.title}</h4>
                <p className="text-white text-sm md:text-base leading-relaxed">{product.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}